import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const BlackPointStatus = types.compose(
  BaseEntity,
  types.model('BlackPointStatus', {
    blackPointStatusId: types.identifierNumber,
    code: types.maybe(types.string),
    name: types.maybe(types.string),
    orderNr: types.number,
  }),
);
